import React, { useContext } from "react";
import { useMessageSource } from "react-message-source";
import ApplicationPageContent from "../../ui/layout/page/content/application";
import SectionFullWidthContainer from "../../ui/layout/page/forms-container/section-full-width-container";
import SectionItemContainer from "../../ui/layout/page/forms-container/section-item-container";
import TypographyContainer from "../../ui/layout/page/typography-container/typography-base-container";
import TypographyItemContainer from "../../ui/layout/page/typography-container/typography-item-container";
import FlowHeader from "../../ui/widgets/flow-header";
import InfoBox from "../../ui/widgets/infobox";
import CustomTypography from "../../ui/widgets/typography";
import ProductImage from "../shared/components/product-image";
import AccountForm from "./account-form";
import { RegistrationModel } from "./types";
import { OnTermsAndConditionsRetrievedApi } from "iam-client/dist/wrapper/shared";
import { Term } from "iam-client/dist/client/shared/termsOfServices";
import { ProductContext } from "../../context/product-context/productContext";
import { useNavigate } from "react-router-dom";

export type RegistrationProps = {
  isUpdateMode?: boolean;
  initial: RegistrationModel;
  context: {
    companyName: string;
    terms: Term[];
  };
  previous: () => void;
  submitHandler: (model: RegistrationModel) => void;
  iamHandler?: OnTermsAndConditionsRetrievedApi;
};

const Registration = ({
  isUpdateMode = false,
  initial,
  context,
  previous,
  submitHandler,
  iamHandler,
}: RegistrationProps): React.JSX.Element => {
  const { getMessage } = useMessageSource();
  const navigate = useNavigate();
  const { selectedProduct } = useContext(ProductContext);
  return (
    <>
      <FlowHeader
        title={getMessage("FlowHeader.basicAccountApplication")}
        image={<ProductImage product={selectedProduct?.productRef} />}
        subTitle={context.companyName}
      />
      <ApplicationPageContent>
        <TypographyContainer>
          <TypographyItemContainer>
            <CustomTypography variant="h3">
              {getMessage("AdminAccount")}
            </CustomTypography>
          </TypographyItemContainer>
          <TypographyItemContainer>
            <CustomTypography variant="body1">
              {isUpdateMode
                ? getMessage("AdminAccount.Update-description")
                : getMessage("AdminAccount-description")}
            </CustomTypography>
          </TypographyItemContainer>
        </TypographyContainer>
        {!isUpdateMode && (
          <div className={"scd-section-pusher-md"}>
            <SectionFullWidthContainer>
              <SectionItemContainer>
                <InfoBox
                  title={getMessage(
                    "Registration.existingSwisscardLoginAccount",
                  )}
                  content={getMessage(
                    "Registration.existingSwisscardLoginAccountDescription",
                  )}
                  onLinkClick={() => navigate("/login")}
                  link={getMessage("Registration.loginWithSwisscardLogin")}
                />
              </SectionItemContainer>
            </SectionFullWidthContainer>
          </div>
        )}
        <div className="scd-section-pusher-lg">
          <TypographyContainer>
            <CustomTypography variant="h4" className="scd-container-base-small">
              {getMessage("AdminAccount")}
            </CustomTypography>
          </TypographyContainer>
        </div>
        <div className="scd-section-pusher-md">
          <AccountForm
            iamHandler={iamHandler}
            isUpdateMode={isUpdateMode}
            terms={context.terms}
            initial={initial}
            submitHandler={submitHandler}
            previous={previous}
          />
        </div>
      </ApplicationPageContent>
    </>
  );
};

export default Registration;
